import script from "./InvoicesNext30Days.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoicesNext30Days.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__